import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import Auth from '@/components/auth/Auth.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Toolbar',
  setup(__props) {

const store = useStore();

const year = ref<number>(new Date().getUTCFullYear());
const loggedIn = computed<boolean>(() => store.state.loggedIn);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass('toolbar-' + (_unref(loggedIn) ? 'visible' : 'transparent'))
  }, [
    (_unref(loggedIn))
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              to: "/",
              exact: "",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Games")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              to: "/hardware",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Hardware")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              to: "/stores",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Stores")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              to: '/purchases/' + year.value,
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Purchases")
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              to: "/wishlist",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Wishlist")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              to: "/schedule/",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Schedule")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Auth)
  ], 2))
}
}

})